
import Task1 from  "@images/icon/task1.png";
import Task2 from  "@images/icon/task2.png";
import Task3 from  "@images/icon/task3.png";
import Task4 from  "@images/icon/Task4.png";
import Task5 from  "@images/icon/task5.png";
import Task6 from  "@images/icon/task6.png";
import Task7 from  "@images/icon/task7.png";
import Task8 from  "@images/icon/task8.png";
export const getLogo = (type) => {
    switch (type) {
      case 1:
        return {
          icon: Task1,
          btnText: "去购物"
        };
      case 2:
        return {
          icon: Task4,
          btnText: "去绑定"
        };
      case 3:
        return {
          icon: Task8,
          btnText: "去授权"
        };
      case 4:
        return {
          icon: Task5,
          btnText: "去完成"
        };
      case 5:
        return {
          icon: Task4,
          btnText: "去浏览"
        };
      case 6:
        return {
          icon: Task5,
          btnText: "去搜索"
        };
      case 7:
        return {
          icon: Task6,
          btnText: "去完成"
        };
      case 8:
        return {
          icon: Task7,
          btnText: "去完成"
        }; 
      case 9:
        return {
          icon: Task1,
          btnText: "去购物"
        };
        case 13:
          return {
            icon: Task2,
            btnText: "去签到"
          };
        case 14:
          return {
            icon: Task6,
            btnText: "去签到"
          };
        case 15:
            return {
              icon: Task3,
              btnText: "去完成"
            };
      default:
        return {};
    }
  }